/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import FormField from "components/FormField";

function Form({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { domain, username, password } = formField;
  const { domain: domainV, username: usernameV, password: passwordV } = values;

  return (
    <MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormField
            type={domain.type}
            label={domain.label}
            name={domain.name}
            value={domainV}
            placeholder={domain.placeholder}
            error={errors.domain && touched.domain}
            success={domainV.length > 0 && !errors.domain}
          />
        </Grid>

        <Grid item xs={12}>
          <FormField
            type={username.type}
            label={username.label}
            name={username.name}
            value={usernameV}
            placeholder={username.placeholder}
            error={errors.username && touched.username}
            success={usernameV.length > 0 && !errors.username}
          />
        </Grid>

        <Grid item xs={12}>
          <FormField
            type={password.type}
            label={password.label}
            name={password.name}
            value={passwordV}
            placeholder={password.placeholder}
            error={errors.password && touched.password}
            success={passwordV.length > 0 && !errors.password}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Form;
